module.exports = __webpack_public_path__ + "static/media/slotsBackgroundEl.e58c1eb8.png";